import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { AvailabilityFactory } from "../../../availability/AvailabilityFactory";
import { ApplicationData } from "../../ApplicationData";
import { AvailabilityClientManager } from "../../ClientManagers/AvailabilityClientManager";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { LS2PAC_Utils } from "../../utils/Utils";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BaseResultsView } from "./BaseResultsView";
import * as React from 'react';
import { ResultButtons } from "@tlc/ls2pac/components/ResultButtons";
import { RateAndReview } from "@tlc/ls2pac/components/RateAndReview";
import { renderInShadow, renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";

export class ReservesResultsView extends BaseResultsView {
  constructor(options) {
    super($.extend(true, {}, options));

    this.resultsTemplate = "tmpl/results/reserves/reservesResults.html";
    this.availabilityTemplate = "tmpl/results/listView_availability.html";

    this.viewSupportsRatings = true;
    this.resources = [];
    this.searchResponse = null;
    this.fetchAvailabilityOnSearchResults =
      options.fetchAvailabilityOnSearchResults || true;
    this.viewName = "reservesView";

    this.availabilitySuffix =
      options.availabilitySuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.availabilitySuffix;
    this.footerControlsSuffix =
      options.footerControlsSuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.footerControlsSuffix;
    this.resultItemCallAndCollSuffix =
      options.resultItemCallAndCollSuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.resultItemCallAndColl;
  }
  loadResults(event, onChangeViewEvent) {
    var _this = this;
    this.resources = event.data.resources;

    if (event.success) {
      TemplateEngine.fetch(
        _this.resultsTemplate,
        $("#" + _this.resultsId),
        _this.resources,
        function () {
          _this.refreshAvailability();

          $.each(_this.resources, function (index, resource) {
            $(
              "#" +
                resource.id +
                LS2PAC_CONSTANTS.Ids.SearchPage.bookJacketSuffix
            ).addCoverArt(
              LibraryThing.enums.requestType.bookJacketSmall,
              _this.resources,
              index,
              true
            );

            if (resource.ratingInformation && _this.viewSupportsRatings) {

              const { resourceId, average, onClickReview } =
                LS2PAC_Utils.getRatingsConfiguration(resource);
              const container = document.querySelector(
                "#" +
                  
                  LS2PAC_CONSTANTS.Ids.SearchPage.ratingsSuffix +
                  resource.id 
              );
              renderInShadow(
                <RateAndReview
                  resourceId={resourceId}
                  averageRating={average}
                  onClickReview={onClickReview}
                ></RateAndReview>,
                container,
                ApplicationData.language
              );

            }
          });
        },
        TemplateEngine.method.overwrite
      );
    } else {
      $("#" + this.resultsId).empty();
    }
  }
  renderButtons(resource) {

      const container = document.querySelector(`#${this.footerControlsSuffix}${resource.id}`);
      renderWithoutShadow(
        <ResultButtons
          resource={resource}
          onClickAddToList={(event) => {
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onOpenAddToList, {
              element: $(event.currentTarget),
              resourceIds: [resource.id],
            });
          }}
          onClickCheckoutDownloadable={(event, resource) => {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
              {
                resource,
                referrer: "Results",
              }
            );
          }}
          onClickPlaceRequest={(event, resource) => {
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRequest, {
              resource,
              referrer: "Results",
            });
          }}
        ></ResultButtons>,
        container,
        ApplicationData.language
      );
      
    

  }
  refreshAvailability() {
    var _this = this;

    if (_this.fetchAvailabilityOnSearchResults) {
      if (window.isIE8 == false) {
        $("#" + _this.id)
          .find(".availabilityLink")
          .spin("tiny");
      }
      AvailabilityClientManager.getItemAvailability(
        _this.resources,
        function (resources, wentToServer, success) {
          _this.renderAvailability(_this.resources, success);
        }
      );
    }
  }
  renderAvailability(resources, success) {
    var _this = this;
    $.each(resources, function (index, resource) {
      if (success == false) {
        return;
      }

      var resultItemCallAndColl = $(
        "#" + resource.id + _this.resultItemCallAndCollSuffix
      );

      resource.reserved = true;

      AvailabilityFactory.displayAvailability(
        resource.id + _this.availabilitySuffix,
        resource
      );

      resultItemCallAndColl.html(
        LS2PAC_Utils.getCallAndCollectionBasedOnAvailability(resource, true)
      );

      _this.renderButtons(resource);
    });
  }
  addListeners() {
    super.addListeners();

    this.addListener(
      LS2PAC_CONSTANTS.Events.onLoginResponse,
      (event) => {
        if (event.success) {
          if (
            $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchPageView).is(
              ":visible"
            )
          ) {
            if (
              LS2PacSearchDatabaseManager.getCurrentDatabaseKey() ==
              LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.reserves.key
            ) {
              this.refreshAvailability();
            }
          }
        }
      }
    );
  }
}
